import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=ce50a10c&"
import script from "./ImageItem.vue?vue&type=script&lang=js&"
export * from "./ImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=ce50a10c&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default})
